<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Validate Bank Account'"
      [canGoBack]="true"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    <tidy-row>
      <tidy-text
        [body]="'Validate your Bank Account by entering the microdeposit amount or code you received.'" />
    </tidy-row>

    <tidy-card>
      <form [formGroup]="form">
        <tidy-radio-button
          [label]="'Choose from the following options: '"
          formControlName="amountOrCode"
          [form]="form.controls.amountOrCode"
          [items]="amountOrCodeItems"
          (optionChange)="selectAmountOrCode($event)" />

        <div style="margin-bottom: 1rem">
          @if (form.controls.amountOrCode.value === 'code') {
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-input
                formControlName="value1"
                [form]="form.controls.value1"
                [label]="'Enter the code'"
                [icon]="'assets/svg/key.svg'"
                [errorMessage]="'Please enter the code'"
                [submitted]="submitted" />
            </tidy-row>
          }
          @if (form.controls.amountOrCode.value === 'amount') {
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-input
                formControlName="value1"
                [form]="form.controls.value1"
                [label]="'Enter the first amount'"
                [icon]="'assets/svg/card.svg'"
                [errorMessage]="'Please enter the first amount'"
                inputMode="numeric"
                [mask]="'currencyMask'"
                [submitted]="submitted" />
              <tidy-input
                formControlName="value2"
                [form]="form.controls.value2"
                [label]="'Enter the second amount'"
                [icon]="'assets/svg/card.svg'"
                [errorMessage]="'Please enter the second amount'"
                inputMode="numeric"
                [mask]="'currencyMask'"
                [submitted]="submitted" />
            </tidy-row>
          }
        </div>
      </form>

      <tidy-error-message [text]="errorMessage" />
    </tidy-card>

    <tidy-row>
      <tidy-button
        [text]="'Confirm'"
        [action]="boundValidateBankAccount"
        class="primary" />
    </tidy-row>
    <tidy-error-message [text]="errorMessage" />
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
